import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { FEATURES_PANEL_TYPES } from '@store';

@Pipe({
  name: 'translatePanelName',
})
export class TranslatePanelNamePipe implements PipeTransform {
  constructor(private translate: TranslateService) {}

  transform(panelName: string): string {
    switch (panelName) {
      case FEATURES_PANEL_TYPES.System:
        return `${this.translate.instant('+INSTALLATIONS.INSTALLATION.PANEL.BOILER')}`;
      case FEATURES_PANEL_TYPES.CommunicationModule:
        return `${this.translate.instant('+INSTALLATIONS.INSTALLATION.GATEWAY.TITLE')}`;
      case FEATURES_PANEL_TYPES.NotificationTile:
        return `${this.translate.instant('+INSTALLATIONS.INSTALLATION.NOTIFICATION.TITLE')}`;
      case FEATURES_PANEL_TYPES.Dhw:
        return `${this.translate.instant('+INSTALLATIONS.INSTALLATION.PANEL.WARM_WATER')}`;
      case FEATURES_PANEL_TYPES.ElectricConsumption:
        return `${this.translate.instant(
          '+INSTALLATIONS.INSTALLATION.PANEL.ENERGY_COCKPIT.ELECTRICAL_CONSUMPTION'
        )}`;
      case FEATURES_PANEL_TYPES.ElectricHeater:
        return `${this.translate.instant('+INSTALLATIONS.INSTALLATION.PANEL.ELECTRIC_HEATER')}`;
      case FEATURES_PANEL_TYPES.EnergyCockpit:
        return `${this.translate.instant(
          '+INSTALLATIONS.INSTALLATION.PANEL.ENERGY_COCKPIT.TITLE'
        )}`;
      case FEATURES_PANEL_TYPES.FuelCell:
        return `${this.translate.instant('+INSTALLATIONS.INSTALLATION.PANEL.FUEL_CELL.TITLE')}`;
      case FEATURES_PANEL_TYPES.GasConsumption:
        return `${this.translate.instant('+INSTALLATIONS.INSTALLATION.GAS_CONSUMPTION')}`;
      case FEATURES_PANEL_TYPES.PowerProduction:
        return `${this.translate.instant('+INSTALLATIONS.INSTALLATION.POWER_PRODUCTION')}`;
      case FEATURES_PANEL_TYPES.HeatProduction:
        return `${this.translate.instant('+INSTALLATIONS.INSTALLATION.HEAT_PRODUCTION')}`;
      case FEATURES_PANEL_TYPES.SolarPowerProduction:
        return `${this.translate.instant('+INSTALLATIONS.INSTALLATION.SOLAR_POWER_PRODUCTION')}`;
      case FEATURES_PANEL_TYPES.HeatingZone:
        return `${this.translate.instant('+INSTALLATIONS.INSTALLATION.PANEL.HEATING_ZONE')}`;
      case FEATURES_PANEL_TYPES.HeatingZone1:
        return `${this.translate.instant('+INSTALLATIONS.INSTALLATION.PANEL.HEATING_ZONE')} 1`;
      case FEATURES_PANEL_TYPES.HeatingZone2:
        return `${this.translate.instant('+INSTALLATIONS.INSTALLATION.PANEL.HEATING_ZONE')} 2`;
      case FEATURES_PANEL_TYPES.HeatingZone3:
        return `${this.translate.instant('+INSTALLATIONS.INSTALLATION.PANEL.HEATING_ZONE')} 3`;
      case FEATURES_PANEL_TYPES.Photovoltaics:
        return `${this.translate.instant('+INSTALLATIONS.INSTALLATION.PHOTOVOLTAICS.TITLE')}`;
      case FEATURES_PANEL_TYPES.SingleRoomControl:
        return `${this.translate.instant('+INSTALLATIONS.SRC.SINGLE_ROOM_CONTROL')}`;
      case FEATURES_PANEL_TYPES.Solar:
        return `${this.translate.instant('+INSTALLATIONS.INSTALLATION.SOLAR.TITLE')}`;
      case FEATURES_PANEL_TYPES.Ventilation:
        return `${this.translate.instant('+INSTALLATIONS.INSTALLATION.PANEL.VENTILATION')}`;
      case FEATURES_PANEL_TYPES.Autarky:
        return `${this.translate.instant('+INSTALLATIONS.INSTALLATION.AUTARKY')}`;
      case FEATURES_PANEL_TYPES.Battery:
        return `${this.translate.instant('+INSTALLATIONS.INSTALLATION.BATTERY.TITLE')}`;
      case FEATURES_PANEL_TYPES.HeatingCircuit0:
        return `${this.translate.instant('+INSTALLATIONS.INSTALLATION.PANEL.CIRCUIT')} 1`;
      case FEATURES_PANEL_TYPES.HeatingCircuit1:
        return `${this.translate.instant('+INSTALLATIONS.INSTALLATION.PANEL.CIRCUIT')} 2`;
      case FEATURES_PANEL_TYPES.HeatingCircuit2:
        return `${this.translate.instant('+INSTALLATIONS.INSTALLATION.PANEL.CIRCUIT')} 3`;
      case FEATURES_PANEL_TYPES.HeatingCircuit3:
        return `${this.translate.instant('+INSTALLATIONS.INSTALLATION.PANEL.CIRCUIT')} 4`;
      case FEATURES_PANEL_TYPES.RefrigerantCircuit0:
        return `${this.translate.instant(
          '+INSTALLATIONS.INSTALLATION.PANEL.REFRIGERANT_CIRCUIT'
        )} 1`;
      case FEATURES_PANEL_TYPES.RefrigerantCircuit1:
        return `${this.translate.instant(
          '+INSTALLATIONS.INSTALLATION.PANEL.REFRIGERANT_CIRCUIT'
        )} 2`;
      case FEATURES_PANEL_TYPES.RefrigerantCircuit2:
        return `${this.translate.instant(
          '+INSTALLATIONS.INSTALLATION.PANEL.REFRIGERANT_CIRCUIT'
        )} 3`;
      case FEATURES_PANEL_TYPES.RefrigerantCircuit3:
        return `${this.translate.instant(
          '+INSTALLATIONS.INSTALLATION.PANEL.REFRIGERANT_CIRCUIT'
        )} 4`;
      case FEATURES_PANEL_TYPES.BufferTank:
        return `${this.translate.instant('+INSTALLATIONS.INSTALLATION.BUFFER_TANK.TITLE')}`;
      case FEATURES_PANEL_TYPES.RemoteController:
        return `${this.translate.instant('+INSTALLATIONS.INSTALLATION.REMOTE_CONTROLLER.TITLE')}`;
      case FEATURES_PANEL_TYPES.ViCarePlans:
        return `${this.translate.instant('+INSTALLATIONS.INSTALLATION.VICARE_PLANS.TITLE')}`;
      case FEATURES_PANEL_TYPES.ViCareThermostat:
        return `${this.translate.instant('+INSTALLATIONS.INSTALLATION.VICARE_THERMOSTAT.TITLE')}`;
      case FEATURES_PANEL_TYPES.SummaryGasConsumption:
        return `${this.translate.instant('+INSTALLATIONS.INSTALLATION.SUMMARY_GAS_CONSUMPTION')}`;
      case FEATURES_PANEL_TYPES.SummaryElectricityConsumption:
        return `${this.translate.instant(
          '+INSTALLATIONS.INSTALLATION.SUMMARY_ELECTRICITY_CONSUMPTION'
        )}`;
      case FEATURES_PANEL_TYPES.BatteryOverall:
        return `${this.translate.instant('+INSTALLATIONS.INSTALLATION.BATTERY_OVERALL_TITLE')}`;
      case FEATURES_PANEL_TYPES.PhotovoltaicOverall:
        return `${this.translate.instant(
          '+INSTALLATIONS.INSTALLATION.PHOTOVOLTAIC_OVERALL_TITLE'
        )}`;
      case FEATURES_PANEL_TYPES.WallboxChargingMode:
        return `${this.translate.instant(
          '+INSTALLATIONS.INSTALLATION.WALLBOX.CHARGING_MODE_TILE'
        )}`;
      case FEATURES_PANEL_TYPES.WallboxSystem:
        return `${this.translate.instant('+INSTALLATIONS.INSTALLATION.WALLBOX.SYSTEM_TILE')}`;
      case FEATURES_PANEL_TYPES.InternalHydraulic:
        return `${this.translate.instant('+INSTALLATIONS.INSTALLATION.PANEL.INTERNAL_HYDRAULIC')}`;
      case FEATURES_PANEL_TYPES.HybridProControl:
        return `${this.translate.instant('+INSTALLATIONS.INSTALLATION.PANEL.HYBRID_PRO.TITLE')}`;
    }
  }
}
